'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import { getDataTypeDisplayLabel } from '../extra/helpers'

/** 項目情報モーダル用ボディ（chrofy項目名クリックで表示）。データ種類・項目名・説明・データ型・サンプルを表示。useModal の body として渡す。 */
const ColumnInfoModal = ({ column }) => {
  const name = column?.column_name ?? column?.column_code ?? ''
  const description = column?.column_description ?? '-'
  const dataType = getDataTypeDisplayLabel(column?.column_data_type)
  const sample = column?.column_sample ?? '-'
  // データ種類（= データ分類名）。flattenHorizontalColumns が横軸ブロックから各列に付与する
  const dataKind = column?.data_classification_name ?? '-'

  const rows = [
    { label: 'データ種類', value: dataKind },
    { label: '項目名', value: name || '-' },
    { label: '説明', value: description },
    { label: 'データ型', value: dataType },
    { label: 'サンプル', value: sample }
  ]

  return (
    <div className="px-4 pt-5 pb-4 overflow-y-auto flex-1 grey--text">
      <table className="form-table table-fixed w-full">
        <tbody className="text-caption-2">
          {rows.map(({ label, value }) => (
            <tr key={label}>
              <th className="form-table__col-head w-[180px]">
                <span className="text-h7 font-bold">{label}</span>
              </th>
              <td className="form-table__col-data">
                <span
                  className={`text-h7 ${label === 'データ種類' || label === '項目名' ? 'font-bold' : ''} ${label === 'サンプル' ? 'column-info-modal__sample-value' : ''}`}
                >
                  {value}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

ColumnInfoModal.propTypes = {
  column: PropTypes.shape({
    column_code: PropTypes.string,
    column_name: PropTypes.string,
    column_description: PropTypes.string,
    column_data_type: PropTypes.string,
    column_sample: PropTypes.string,
    data_classification_name: PropTypes.string
  })
}

ColumnInfoModal.defaultProps = {
  column: null
}

export default ColumnInfoModal
